import { Breadcrumbs as RDCBreadcrumbs } from '@uncinc/react-drupal-core';
import * as React from 'react';

import './style.scss';

interface BreadcrumbProps {
  includeCurrent?: boolean;
}

const Breadcrumbs = ({ includeCurrent }: BreadcrumbProps) => (
  <RDCBreadcrumbs includeCurrent={includeCurrent} />
);

export default Breadcrumbs;
